import CheckCirclelIcon from '@mui/icons-material/CheckCircle'

const Icon = () => {
  return (
    <CheckCirclelIcon
      htmlColor='rgb(56 142 60)'
      fontSize='medium'
    />
  )
}

export default Icon
